import { createAction } from 'deox';

export const resetStore = createAction('app/RESET_STORE');

export const setNotification = createAction(
  'app/SET_NOTIFICATION',
  res => (status: boolean, text?: string, type?: string) => res({ status, type, text }),
);

export const setFirstStart = createAction('app/SET_FIRST_START', res => (payload: boolean) =>
  res(payload),
);

export const setIsLocationCheck = createAction(
  'app/SET_IS_LOCATION_CHECK',
  res => (payload: boolean) => res(payload),
);

export const setWindowWidth = createAction('app/SET_WINDOW_WIDTH', res => (payload: number) =>
  res(payload),
);

export const setCurrentLanguage = createAction(
  'app/SET_CURRENT_LANGUAGE',
  res => (payload: string) => res(payload),
);

export const setCurrentCountry= createAction(
  'app/SET_CURRENT_COUNTRY',
  res => (payload: string) => res(payload),
);
